





































































import { Component, Vue } from 'vue-property-decorator';

import Typography from '@/componentsV2/atoms/Typography/Typography.vue';
import SectionData from '@/componentsV2/organisms/SectionData/SectionData.vue';
import Table from '@/components/molecules/Table/Table.vue';
import TableCell from '@/components/molecules/TableCell/TableCell.vue';
import TableHeader from '@/components/molecules/TableHeader/TableHeader.vue';
import TableRow from '@/components/molecules/TableRow/TableRow.vue';
import TableCard from '@/componentsV2/molecules/TableCard/TableCard.vue';
import DateUtils from '@/utils/DateUtils';
import PaginationUtils, {
  IPagination,
  IPaginationTableHeader
} from '@/utils/PaginationUtils';
import Trigger from '@/componentsV2/molecules/Trigger/Trigger.vue';
import BillingService from '@/api/BillingService';
import eventBus from '@/utils/eventBus';

@Component({
  components: {
    Typography,
    SectionData,
    Table,
    TableCell,
    TableHeader,
    TableRow,
    TableCard,
    Trigger
  }
})
export default class CoinNetworkPlanList extends Vue {
  billingService = new BillingService();

  activities: any = [];

  pagination: IPagination = PaginationUtils.defaultPagination();

  filters: Record<string, any> = {};

  loading = false;

  headers: Record<string, IPaginationTableHeader> = this.mountHeaderTable();

  DateUtils = DateUtils;

  get businessInfo() {
    return this.$store.getters['business/getBusinessState'] || {};
  }

  get billingStatus() {
    return this.businessInfo.subscriptionStatus;
  }

  mountHeaderTable() {
    return {
      createdAt: {
        label: 'Date',
        sortable: true,
        nameColumnOrderBy: 'createdAt'
      },
      message: {
        label: 'Action'
      }
    };
  }

  handleSort(field: string) {
    this.headers = PaginationUtils.getUpdatedHeaders(field, this.headers);

    const { sortDir, nameColumnOrderBy } = this.headers[field];

    const column = nameColumnOrderBy || `${field}`;

    this.filters = {
      ...this.filters,
      sort: `${column}:${sortDir}`
    };
    this.loadCoinNetworkActivities({ clearList: true });
  }

  async loadCoinNetworkActivities({
    clearList = false,
    showLoader = true
  } = {}) {
    if (this.loading) return;
    if (clearList) {
      this.pagination = PaginationUtils.defaultPagination();
    }

    if (!this.pagination.mustCallApi) return;

    let endpointPath = '/admin/billing/activity';

    if (this.pagination.next) {
      endpointPath = this.pagination.next;
    }

    this.loading = true;
    if (showLoader) this.$showLoaderWithLocker();

    const response = await this.billingService.getListActivities(
      endpointPath,
      !this.pagination.next
        ? {
            ...this.filters
          }
        : {}
    );

    if (showLoader) this.$hideLoader();
    this.loading = false;
    if (response && response.status !== 200) return;

    const { links } = response.data;

    Object.assign(this.pagination, {
      next: links.next,
      mustCallApi: !!links.next
    });

    if (clearList) {
      this.activities = response.data.items;
      return;
    }

    this.activities = [...this.activities, ...response.data.items];

    PaginationUtils.makeNewRequest(
      {
        triggerClass: '.infinite-trigger',
        hasPagination: !!this.pagination.next
      },
      () => {
        this.loadCoinNetworkActivities({ showLoader: false });
      }
    );
  }

  mounted() {
    this.loadCoinNetworkActivities({ clearList: true });
  }

  created() {
    eventBus.$on('reloadCoinNetworkActivities', this.loadCoinNetworkActivities);
  }

  beforeDestroy() {
    eventBus.$off(
      'reloadCoinNetworkActivities',
      this.loadCoinNetworkActivities
    );
  }
}
